export const DESCRIPTIONCHARLIMIT = 30;
export const BATCH_LIMIT = 18;
export const NUMBER_OF_RETRIES = 5;
export const RETRY_WAIT_MS = 200;
export const STORE_SPEND_LIMIT = '100000000000000000000000';
export const STORE_MAX_NUMBER_OF_ITEMS = 1;
export const MINIMUM_SKVLLPVNKZ_OWNED = 1;
export const HIDEOUT_ID_LIMIT = 10000;
export const DAYCARE_ID_LIMIT = 5000;
